import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import LegalCargo from './LegalCargo';
import LegalTicket from './LegalTicket';
import LegalManifestCargo from './LegalManifestCargo';
import LegalManifestTicket from './LegalManifestTicket';
import LegalManifestBaggage from './LegalManifestBaggage';

export default combineReducers({
  UnitHome,
  LegalCargo,
  LegalTicket,
  LegalManifestCargo,
  LegalManifestTicket,
  LegalManifestBaggage
});
